"use strict";
// DO NOT EDIT THIS FILE, EDIT THE GULP TASK SETTINGS INSTEAD WHICH GENERATES THIS FILE

angular.module("courseApp", ["ngRoute","ngResource","ngCookies","http-auth-interceptor","ngTable","ui.select","ngSanitize","moment-picker"])
.constant("ATTENDEE_TYPE", [{"id":"T","title":"Teilnehmer"},{"id":"A","title":"Ausbilder"},{"id":"D","title":"Divers"}])
.constant("CONFIG", {"authURL":"https://api.dsv-sportentwicklung.de/api-token-auth/","backendURL":"https://api.dsv-sportentwicklung.de/","apiURL":"https://api.dsv-sportentwicklung.de/api/course/","imagePath":"./images"});
